// extracted by mini-css-extract-plugin
module.exports = {"avatarWrap":"_3epIXuynBT76sqsVhzN4Di","avatar":"_3ESu-GViMau0JtNxCSEkX4"};